//All Products
export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE"

//Solo Products
export const GET_SOLO_REQUEST = "GET_SOLO_REQUEST"
export const GET_SOLO_SUCCESS = "GET_SOLO_SUCCESS"
export const GET_SOLO_FAILURE = "GET_SOLO_FAILURE"

//Related Products
export const GET_RELATED_PRODUCTS_REQUEST = "GET_RELATED_PRODUCTS_REQUEST"
export const GET_RELATED_PRODUCTS_SUCCESS = "GET_RELATED_PRODUCTS_SUCCESS"
export const GET_RELATED_PRODUCTS_FAILURE = "GET_RELATED_PRODUCTS_FAILURE"

//All Products
export const GET_BEST_REQUEST = "GET_BEST_REQUEST"
export const GET_BEST_SUCCESS = "GET_BEST_SUCCESS"
export const GET_BEST_FAILURE = "GET_BEST_FAILURE"

//All Products
export const GET_OLDER_REQUEST = "GET_OLDER_REQUEST"
export const GET_OLDER_SUCCESS = "GET_OLDER_SUCCESS"
export const GET_OLDER_FAILURE = "GET_OLDER_FAILURE"

//All Products
export const GET_UPCOMING_REQUEST = "GET_UPCOMING_REQUEST"
export const GET_UPCOMING_SUCCESS = "GET_UPCOMING_SUCCESS"
export const GET_UPCOMING_FAILURE = "GET_UPCOMING_FAILURE"
 
//Total Products
export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS" 

//Post a Product
export const POST_PRODUCT = "POST_PRODUCT"

//Get promotional Products
export const GET_PROMOTIONAL_PRODUCTS = "GET_PROMOTIONAL_PRODUCTS" 


